import { CATEGORY_TYPE, SUB_CATEGORY_TYPE } from '../constants/edit/CategorizeConstants';
import { EMPTY_STRING } from '../constants/SharedConstants';
import { INVALID_SMART_QUOTES, INVALID_SMART_AND_CJK_PUNCTUATION, INVALID_SLUG_CHAR_MATCHER } from '../constants/edit/SlugConstants';
import { isBlank } from './stringUtils';
export function getCategoryType(parentCategory) {
  return parentCategory && parentCategory.id !== 0 ? SUB_CATEGORY_TYPE : CATEGORY_TYPE;
}
export function getMultiLangCategoryType(parentCategoryId) {
  return parentCategoryId ? SUB_CATEGORY_TYPE : CATEGORY_TYPE;
}
export function getDropDownOptions(categories) {
  if (categories) {
    return categories.map(category => {
      return {
        text: category.name,
        value: category.id
      };
    }).toArray();
  }
  return [];
}
export function getSelectedCategory(categoryId, categories) {
  if (categoryId && categoryId !== 0 && categories) {
    return categories.find(category => {
      const {
        subcategories
      } = category;
      return String(category.id) === String(categoryId) || getSelectedCategory(categoryId, subcategories);
    });
  }
  return undefined;
}
export function getSelectedSubCategory(categoryId, selectedCategory) {
  return selectedCategory ? getSelectedCategory(categoryId, selectedCategory.subcategories) : undefined;
}
export const getMultiLangDropDownOptions = (categories, primaryLanguage, language) => {
  if (!categories) {
    return [];
  }
  return categories.map(category => {
    return {
      value: category.get('knowledgeCategoryId'),
      primaryLanguage,
      articleLanguage: language,
      translations: category.get('nameTranslations').toJS()
    };
  }).toArray();
};
export function getSelectedMultiLangCategory(categoryOrSubcategoryId, categories) {
  if (categoryOrSubcategoryId && categoryOrSubcategoryId !== 0 && categories) {
    return categories.find(category => {
      const subcategories = category.get('subcategories');
      return Boolean(category.get('knowledgeCategoryId') === categoryOrSubcategoryId || getSelectedMultiLangCategory(categoryOrSubcategoryId, subcategories));
    });
  }
  return undefined;
}
export function getSelectedKnowledgeCategoryId(categoryOrSubcategoryId, categories) {
  if (categoryOrSubcategoryId && categoryOrSubcategoryId !== 0 && categories) {
    const selectedCategory = categories.find(category => {
      const subcategories = category.get('subcategories');
      return category.get('knowledgeCategoryId') === categoryOrSubcategoryId || getSelectedMultiLangCategory(categoryOrSubcategoryId, subcategories);
    });
    return selectedCategory && selectedCategory.get('knowledgeCategoryId');
  }
  return undefined;
}
export function getSelectedMultiLangSubcategory(categoryId, selectedCategory) {
  return selectedCategory ? getSelectedMultiLangCategory(categoryId, selectedCategory.get('subcategories')) : undefined;
}
export function getSelectedMultiLangSubcategoryId(categoryId, selectedCategory) {
  const selectedSubcategory = selectedCategory ? getSelectedMultiLangCategory(categoryId, selectedCategory.get('subcategories')) : undefined;
  return selectedSubcategory && selectedSubcategory.get('knowledgeCategoryId');
}
export const getCategoriesPrimaryLanguage = categories => {
  return categories.get('primaryLanguage');
};
export const getLanguageTranslation = (langTranslations, language) => langTranslations && langTranslations.find(translation => translation.language === language);
export function slugify(str) {
  if (isBlank(str)) {
    return EMPTY_STRING;
  }
  let slug;
  slug = str.trim();
  slug = slug.replace(INVALID_SMART_QUOTES, EMPTY_STRING);
  slug = slug.replace(INVALID_SMART_AND_CJK_PUNCTUATION, '-');
  slug = slug.replace(INVALID_SLUG_CHAR_MATCHER, EMPTY_STRING);
  slug = slug.replace(/_/gi, '-');
  slug = slug.replace(/\s/gi, '-');
  return slug.toLowerCase();
}